import axios from 'axios'
import Auth from '@/services/auth'
import {
  API_BASE,
  apiErrorHandler,
  ApiFilter,
  isDefinedAndNotNull,
  isNotEmpty,
} from '@/services/api'

const PINWHEEL_ENDPOINT = `${API_BASE}pinwheel/`

const PinwheelApi = {
  getRequestOptions() {
    return {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
  },

  // Get a Verification link token
  async getVerificationLinkToken(language, subOrgId = null) {
    try {
      const response = await axios.get(PINWHEEL_ENDPOINT + 'get_verification_link_token', {
        params: {
          language: language,
          sub_org_id: subOrgId,
        },
        ...this.getRequestOptions(),
      })
      const link_token = response.data

      return link_token.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Get a payroll switch link token
  async getPayrollContributionLinkToken(language, amount) {
    try {
      const response = await axios.get(PINWHEEL_ENDPOINT + 'get_payroll_contribution_link_token', {
        params: {
          language: language,
          amount: amount,
        },
        ...this.getRequestOptions(),
      })
      const link_token = response.data

      return link_token.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Get the link ID
  async getLinkId() {
    try {
      const response = await axios.get(PINWHEEL_ENDPOINT + 'get_link_id', this.getRequestOptions())

      return response.data.link_id
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Get the account ID
  async getAccountId() {
    try {
      const response = await axios.get(
        PINWHEEL_ENDPOINT + 'get_account_id',
        this.getRequestOptions(),
      )

      return response.data.account_id
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Persist the account ID
  async persistAccountId(account_id) {
    try {
      const response = await axios.post(
        PINWHEEL_ENDPOINT + 'persist_account_id',
        { account_id: account_id },
        this.getRequestOptions(),
      )

      return true
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Retrieve account information
  async getIdentity(account_id, options={}) {
    try {
      const response = await axios.post(
        PINWHEEL_ENDPOINT + 'get_identity',
        { account_id: account_id },
        {
          ...options,
          ...this.getRequestOptions(),
        }       
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Retrieve employment information
  async getEmployment(account_id, options={}) {
    try {
      const response = await axios.post(
        PINWHEEL_ENDPOINT + 'get_employment',
        { account_id: account_id },
        {
          ...options,
          ...this.getRequestOptions(),
        }
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Retrieve jobs results
  async getJobs(link_token_id) {
    try {
      const response = await axios.get(PINWHEEL_ENDPOINT + 'get_jobs', this.getRequestOptions())

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Retrieve external donations
  async getUserExternalDonations() {
    try {
      const response = await axios.get(
        PINWHEEL_ENDPOINT + 'get_user_external_donations',
        this.getRequestOptions(),
      )

      return response.data
    } catch (error) {
      console.error(error)
    }

    return null
  },

  // Retrieve account information via the backend
  /*
  async getDirectDepositAllocations(account_id) {
    try {
      const response = await axios.get(PINWHEEL_ENDPOINT + "get_direct_deposit_allocations", {
        params: {
          "account_id": account_id,
        },
        ...this.getRequestOptions(),
      })

      return response.data.data
    } catch (error) {
      console.error(error)
    }

    return null
  },
  */
}

export default PinwheelApi
